module.exports = __webpack_public_path__ + "img/88404.24479e12.svg";